import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: any = '';

export const currentPrincipalFilterSlice = createSlice({
  name: 'currentPrincipalFilter',
  initialState,
  reducers: {
    currentPrincipalFilter: (state, action: PayloadAction<any>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { currentPrincipalFilter } = currentPrincipalFilterSlice.actions;

export default currentPrincipalFilterSlice.reducer;
